/* import __COLOCATED_TEMPLATE__ from './contact-for-team-billing-container.hbs'; */
import Component from '@glimmer/component';

export default class ContactForTeamBillingContainer extends Component {}
